import { TagData } from '../../../Tags/types'

export interface Fullscreen {
  toggle: () => void
  isFullscreen: () => boolean
}

export type Placeholder = {
  label: string
  value: string
  description?: string
  children?: Array<Placeholder>
  tags?: Array<TagData>
}

export type Stack = {
  sectionTitle?: string
  sections: Array<
    {
      buttonTitle: string
      description?: string
      placeholders: Array<Placeholder>
    }
  >
}

export type PlaceholdersStack = {
  type: PlaceholdersType.Stack
  placeholders: Array<Stack>
}

export type PlaceholdersOnes = {
  type: PlaceholdersType.Ones
  placeholders: Array<Placeholder>
}

export enum PlaceholdersType {
  Stack,
  Ones,
}

export type ToolBarSettings = {
  disabledPanelElements: Array<string>
  placeholders: PlaceholdersOnes | PlaceholdersStack
  fullscreen: Fullscreen
}
